<!-- Small/Medium viewport -->
<ul class="d-block d-lg-none list-group">
  <li class="list-group-item d-flex justify-content-between align-items-center subheader pt-1 pb-1">
    <div class="col-12">
      <strong>{{ 'Request.Document.Document' | translate }} {{documentIndex}}</strong>
    </div>
  </li>
  <li class="list-group-item d-flex justify-content-between align-items-center pt-1 pb-1">
    <div class="col-3 col-md-2 text-truncate">
      <span (click)="openPreview()" translate>Request.ReviewSend.DocumentName</span>
    </div>
    <div class="col-9 col-md-10 text-truncate">
      <span>{{document.name}}</span>
    </div>
  </li>
  <li class="list-group-item d-flex justify-content-between align-items-center pt-1 pb-1">
    <div class="col-3 col-md-2 text-truncate">
      <span translate>Request.ReviewSend.Type</span>
    </div>
    <div class="col-9 col-md-10 text-truncate">
      <span>{{'Request.Document.'+document.documentType | translate }}</span>
    </div>
  </li>
  <li class="list-group-item d-flex justify-content-between align-items-center pt-1 pb-1">
    <div class="col-3 col-md-2 text-truncate">
      <span translate>Request.ReviewSend.Filesize</span>
    </div>
    <div class="col-9 col-md-10 text-truncate">
      <span>{{document.fileSize | byteSizePipe}}</span>
    </div>
  </li>
</ul>

<!-- Large viewport -->
<div class="row w-100 d-none d-lg-flex p-0 align-items-center">
    <div class="col-4 firstcol text-truncate">{{document.name}}</div>
    <div class="col-4 text-truncate">{{document.id}}</div>
    <div class="col-2 text-truncate">{{document.filetype}}</div>
    <div class="col-1 text-truncate">{{document.fileSize | byteSizePipe}}</div>
    <div class="col-1">
      <span class="float-end">
        <div class="btn-group" *ngIf="document.documentType !== 'UnrenderedFile'">
          <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="bi bi-three-dots bi-large"></i>
          </button>
          <ul class="dropdown-menu">
            <li *ngIf="document.documentType !== 'UnrenderedFile'"><a class="dropdown-item pt-1 pb-1" (click)="openPreview()" translate>Button.ShowDocument</a></li>
          </ul>
        </div>
      </span>
    </div>
</div>
